let allVideos = document.querySelectorAll('.reading-item');

allVideos.forEach(async (item) => {
  item.addEventListener("click", function(e){

    if(e.target.hasAttribute('data-mux')) {
      var videoEmbed = e.target.getAttribute('data-mux');
      document.querySelector('.pastReadingsVideo').innerHTML = `<video class="past-mux-video" poster="https://cdn.shopify.com/s/files/1/1150/7634/files/1796935.jpg?v=1735227129" preload="auto" controls="true" playsinline></video>`;
      if (Hls.isSupported()) {
          var hls = new Hls();
          hls.loadSource(`https://stream.mux.com/${videoEmbed}.m3u8`);
          hls.attachMedia(document.querySelector('.past-mux-video'));
        }
      else if (liveVideo.canPlayType('application/vnd.apple.mpegurl')) {
          document.querySelector('.past-mux-video').src = `https://stream.mux.com/${videoEmbed}.m3u8`;
        }
    }
    
    else if(e.target.hasAttribute('data-cloudflare')) {
      var videoEmbed = e.target.getAttribute('data-cloudflare');
      document.querySelector('.pastReadingsVideo').innerHTML = `<video-js class="video-js popupVideo popupPlayer" preload="auto" controls="true"></video-js>`;
      var popupVideo = videojs(document.querySelector('.popupPlayer'));
      popupVideo.src({
        type: 'application/x-mpegURL',
        src: videoEmbed
      }); 
    }
    else {
      var videoEmbed = e.target.getAttribute('data-video');
      document.querySelector('.pastReadingsVideo').innerHTML = videoEmbed;
    }
    document.querySelector('.pastReadingsContain').classList.add('showVideo');
  });
});

document.querySelector('.pastReadingsOverlay').addEventListener("click", function(e){
    document.querySelector('.pastReadingsContain').classList.remove('showVideo');
    document.querySelector('.pastReadingsVideo').innerHTML = '';
});

document.querySelector('.pastReadingsClose').addEventListener("click", function(e){
    document.querySelector('.pastReadingsContain').classList.remove('showVideo');
    document.querySelector('.pastReadingsVideo').innerHTML = '';
});